import { render, staticRenderFns } from "./VisaoGeral.vue?vue&type=template&id=41767817&scoped=true"
import script from "./VisaoGeral.vue?vue&type=script&lang=js"
export * from "./VisaoGeral.vue?vue&type=script&lang=js"
import style0 from "./VisaoGeral.vue?vue&type=style&index=0&id=41767817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41767817",
  null
  
)

export default component.exports